
export const buildSummary = (transfer) => {
    var quickSummary = '';
    if (transfer) {
        var toFarm = !!transfer.destination?.isFarm && !(process.env.REACT_APP_EXTERNAL_APP === 'true') && transfer.source?.isFarm;
        var unit = toFarm ? 'pcs' : 'doz';
        for (var i = 0; i < transfer.coreTransferLines.length; i++) {
            if (transfer.coreTransferLines[i].stockItem) {
                if (i === 0) {
                    quickSummary = transfer.coreTransferLines[i].stockItem.myobid + ':' + transfer.coreTransferLines[i].quantity+' ('+unit+')';
                } else {

                    quickSummary = quickSummary + ', ' + transfer.coreTransferLines[i].stockItem.myobid + ':' + transfer.coreTransferLines[i].quantity+' ('+unit+')';
                }
            }
        }
    }
    return quickSummary;
}